import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import TextField from "@mui/material/TextField";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    Divider,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants";
import { dbCreateTournamentEvent } from "../../../api/api";
import { LocationType, STATUS } from "../../../types/types";
import NotificationService from "../../../components/notification/NotificationService";
import { getGuid } from "../../../utils";
import { createTournamentEvent } from "../../../features/tournamentEvents/tournamentEventsSlice";

const CreateTournamentEvent = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const _locations = useAppSelector((state) => state.locations.locations);
    const _tournament = useAppSelector((state) => state.tournament.tournament);
    const _settings = useAppSelector((state) => state.settings.settings);

    const matches = useAppSelector(state => state.matches.groupMatches);
    const tournamentEvents = useAppSelector(state => state.tournamentEvents.tournamentEvents);

    const [title, setTitle] = useState<string>("");
    const [duration, setDuration] = useState<number>(30);
    const [locationId, setLocation] = useState<string>("");

    const _handleClose = () => {
        navigate(ROUTES.ADMIN_MATCHES);
    };

    const createNewTournamentEvent = () => {
        const _location = _locations.find((location) => location.id === locationId);

        if (!title.trim() || !_location || !duration) {
            NotificationService.showToast({
                severity: "error",
                text: "Udfyld alle felter",
                duration: 3000,
            });
            return;
        }

        // Get all matches and events for the selected location
        const locationMatches = matches.filter(match => match.location.id === locationId);
        const locationEvents = tournamentEvents.filter(event => event.location.id === locationId);
        const allItems = [...locationMatches, ...locationEvents];

        // Calculate start time
        const maxEndTime = Math.max(...allItems.map(item => item.endTime ?? 0));
        const startTime = maxEndTime + ((_settings?.gapTime ?? 0) * 60);

        debugger;
        const endTime = startTime + (duration * 60);

        dbCreateTournamentEvent(
            title,
            duration,
            locationId,
            _tournament.id,
            startTime,
            endTime,
            STATUS.PENDING,
        )
            .then((id: string) => {
                dispatch(
                    createTournamentEvent({
                        id,
                        title,
                        duration,
                        location: _location,
                        tournament: _tournament,
                        startTime,
                        endTime,
                        status: STATUS.PENDING,
                    })
                );
                NotificationService.showToast({
                    severity: "success",
                    text: "Begivenhed oprettet!",
                    duration: 3000,
                });
                _handleClose();
            })
            .catch((e) => {
                console.error(e);
                NotificationService.showToast({
                    severity: "error",
                    text: "Kunne ikke oprette begivenhed",
                    duration: 5000,
                });
            });
    };

    useEffect(() => {
        if (_locations.length > 0) {
            setLocation(_locations[0].id);
        }
    }, []);

    return (
        <Container maxWidth={"sm"}>
            <Stack spacing={3}>
                <Typography variant="h4">Opret turneringsbegivenhed</Typography>
                <Card>
                    <form autoComplete="off" noValidate onSubmit={(e) => e.preventDefault()}>
                        <Card>
                            <CardHeader
                                subheader="Udfyld følgende oplysninger:"
                                title="Ny begivenhed"
                            />
                            <CardContent sx={{ pt: 0 }}>
                                <Box sx={{ m: -1.5 }}>
                                    <Grid container justifyContent="space-between">
                                        <Grid xs={12} padding={1} item>
                                            <TextField
                                                fullWidth
                                                label="Titel"
                                                name="title"
                                                onChange={(e) => setTitle(e.target.value)}
                                                required
                                                value={title}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={6} padding={1} item>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                label="Varighed (minutter)"
                                                name="duration"
                                                value={duration}
                                                onChange={(e) => setDuration(Number(e.target.value))}
                                                required
                                                inputProps={{ min: 1 }}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={6} padding={1} item>
                                            <TextField
                                                fullWidth
                                                label="Bane"
                                                name="location"
                                                onChange={(e) => setLocation(e.target.value)}
                                                required
                                                select
                                                SelectProps={{ native: true }}
                                                value={locationId}
                                            >
                                                {_locations.map((location: LocationType) => (
                                                    <option key={location.id} value={location.id}>
                                                        {location.location}
                                                    </option>
                                                ))}
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                            <Divider />
                            <CardActions sx={{ justifyContent: "flex-end" }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate(ROUTES.ADMIN_MATCHES)}
                                >
                                    Fortryd
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={createNewTournamentEvent}
                                >
                                    Opret
                                </Button>
                            </CardActions>
                        </Card>
                    </form>
                </Card>
            </Stack>
        </Container>
    );
};

export default CreateTournamentEvent;
